import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import { getAllActivitiesPrice } from "../../../pages/Activitespkg/Activitiescheckout/activitiesHelper";
import LogoImg from "../../../assets/images/logos/trip-logo.png";

dayjs.extend(weekday);

// QR helper disabled for PDF generation – previous implementation relied on
// DOM APIs (canvas.toDataURL) that are not available in @react-pdf environment.
// If QR codes are needed in future, they should be provided as ready-to-use URLs
// in the data instead of being read from the DOM.
const getQRImage = () => null;

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    padding: 10,
  },
  section: {
    padding: "0 10px",
    width: "100%", // ensure inner content (cards) spans full page width
  },
  innerSection: {
    position: "relative",
    paddingLeft: 30,
  },
  borderleft: {
    position: "absolute",
    width: 3,
    left: 0,
    height: "100%",
    backgroundColor: "#e9ecef",
  },
  title: {
    fontSize: 12,
    marginBottom: 5,
    color: "#274581",
  },
  subtitle: {
    fontSize: 10,
    marginBottom: 5,
  },
  stitle: {
    fontSize: 10,
  },
  textDanger: {
    color: "#dc3545",
  },

  container: {
    // borderWidth: 1, // Add border to the container to simulate table border
    borderColor: "#ddd", // Light color for the border
  },

  row: {
    display: "flex",
    flexDirection: "row",
    width:"100%",
    justifyContent: "space-between",
    marginBottom: 5,
    flexWrap: "wrap",
    alignItems: 'flex-start', // Vertically center items
    borderBottomWidth: 1, // Optional, to create a line under each row
    borderBottomColor: "#ddd", // Light gray color for border
  },

  leftCell: {
    flex: 1,
    fontSize: 10,
    textAlign: "left", // Left-align the labels
    paddingLeft: 10,
    paddingVertical: 5,
  },

  rightCell: {
    flex: 1,
    fontSize: 10,
    paddingRight: 10,
    marginLeft: 30,
    paddingVertical: 5,
    flexWrap: "wrap",
    wordwrap: "break-word",
    maxWidth: '100%',
    whiteSpace: 'normal',
  },

  verticalLine: {
    position: "absolute", // Position the line between cells
    left: "50%", // Center the line between the two columns
    top: -1,
    bottom: 0,
    width: 1, // The thickness of the vertical line
    backgroundColor: "#ddd", // Color of the vertical line
    height: "100%", // Full height of the row
    alignSelf: "stretch", // Ensures the line stretches to the container's height
  },

  wHalf: {
    width: "50%",
    marginBottom: 5,
  },
  card: {
    position: "relative",
    padding: 10,
    border: "1px solid #e9ecef",
    borderRadius: 2,
    width: "100%", // make the ticket card span full available width on the page
  },
  tourImg: {
    width: 100,
  },
  mb10: {
    marginBottom: 10,
  },
  contentWrapper: {
    position: "relative",
    marginBottom: 10,
    backgroundColor: "#ffffff",
    width: "100%", // make each tour card wrapper use the full available width
  },

  timelineBadge: {
    position: "absolute",
    top: 9,
    left: -46,
    zIndex: 10,
    width: 35,
    height: 35,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    textAlign: "center",
    fontSize: 9,
    color: "#fff",
    backgroundColor: "#ffbc34",
  },
  description: { width: "100%", fontSize: 10, marginBottom: 10, color: "#0c5460", backgroundColor:"#d0e3e7", padding: 10},
  headerWrraper: {
    backgroundColor: "#ffffff",
    padding: "5px 15px",
  },
  mb_5: { marginBottom: 5 },
  addressDetails: {
    textAlign: "right",
    fontSize: 10,
    paddingBottom: 5,
    paddingRight: 10,
    paddingLeft: 10,
  },
  addressBox: {
    borderWidth: 1,
    borderColor: "#E0E0E0",
    padding: 4,
    width: "50%",
  },
  addressText: {
    fontSize: 10,
    textAlign: "right",
    lineHeight: 1.2,
    width: "100%",
  },
  flex5: {
    width: "50%",             // logo left 50%, address right 50% for balanced header
  },
  logoSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  textRight: {
    textAlign: "right",
  },
  alignSelf: {
    alignSelf: "flex-end",
  },
  justifyContentBetween: {
    justifyContent: "space-between",
  },
  // wHalfBar: {
  //   width: "50%",
  //   marginBottom: 5,
  // },
  
  tourImgBar: {
    width: 100,
    height: "100%",
  },
  requestText: {
    color: "#FF0000",
    textAlign: "left", // 'justify' is not supported for Text components in React Native
  },
  description1: {
    width: "100%",
    fontSize: 10,
    marginBottom: 10,
    color: "#0c5460",
    backgroundColor: "#d0e3e7",
    padding: 10,
  },
  note: {
    fontSize: 10,
    marginTop: 2,
    marginBottom: 2,
    lineHeight: 1.5,
    color: "#0c5460",
    textAlign: "justify",
    flexDirection: "row",
  },
  bullet: {
  fontWeight: "bold",
},
  title1: {
    fontSize: 12,
    marginTop: 8,
    textAlign: "center",
    color: "#000",
    fontWeight: "bold",
  },
  row1: {
    marginTop: 6,
    marginBottom: 5,
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderTopWidth: 0,
    borderColor: "#000",
    alignItems: "center",
  },
  headerCell: {
    fontWeight: "bold",
    backgroundColor: "#e0f0f5",
    color:"#000",
    fontSize:15,
  },
  cell: {
    fontSize: 10,
    padding: 2,
    borderRightWidth: 1,
    borderColor: "#000",
    flex: 1,
    borderRightColor: "#000",
    textAlign: "center",
  },
  lastCell: {
    borderRightWidth: 0,
  },
});

const getStatus = (status) => {
  switch (status) {
    case "BLOCKED": {
      return <Text style={{ color: "#FFA500" }}>BLOCKED </Text>;
    }
    case "SUCCESS": {
      return <Text style={{ color: "#008000" }}>{status}</Text>;
    }

    case "CONFIRMED": {
      return <Text style={{ color: "#008000" }}>{status}</Text>;
    }

    case "ALREADYCANCELLED": {
      return <Text style={{ color: "#FF0000" }}>ALREADY CANCELLED</Text>;
    }
    case "CANCELLED": {
      return <Text style={{ color: "#FF0000" }}>{status}</Text>;
    }
    case "VOUCHERED": {
      return <Text style={{ color: "#FF0000" }}>{status}</Text>;
    }
    default:
      return;
  }
};

// Helper: strip HTML tags for safe PDF text rendering
const stripHtml = (htmlString) => {
  if (!htmlString || typeof htmlString !== "string") return "";
  return htmlString.replace(/<[^>]*>?/gm, "");
};

const CancellationDescription = ({ tourShortDescription }) => {
  const cleanText = stripHtml(tourShortDescription);
  return (
    <Text style={{ display: "inline", color: "red" }}>
      {cleanText}
    </Text>
  );
};

const Description = ({ tourShortDescription }) => {
  const cleanText = stripHtml(tourShortDescription);
  return (
    <Text style={{ display: "inline" }}>
      {cleanText}
    </Text>
  );
};

const getPaxCount = (pax) => {
  return `Adult(s) ${pax?.adults !== "0" ? pax?.adults : 0} ${
    pax?.childCount !== "0" ? ", Child(s) " + pax?.childCount : " "
    } ${pax?.infantCount !== "0" ? ", Infant(s) " + pax?.infantCount : " "}`;
};

const ActivitiesDoc = ({
  ticketData,
  withFare,
  agent,
  Logo,
  voucherData,
  activeCurrency,
  currencyValue = () => {},
}) => {
  // Debug logs to help inspect data flowing into the PDF generator.
  const { totalAmount, discount } = getAllActivitiesPrice(
    ticketData.TourDetails,
    ticketData.convienenceData,
    ticketData.promoData
  );
  ticketData.TourDetails = ticketData.TourDetails.filter(
    (x) => x.BookingStatus !== "NOT-AVAILABLE"
  );
  const BASE = process.env.REACT_APP_BASE_URL;
  const getTotalAmount = () => {
    let postMarkup = ticketData.totalPostMarkup
      ? ticketData.totalPostMarkup
      : 0;
    let totalAmount =
      Number(ticketData.PartPayment.serviceTotal) + Number(postMarkup);

    return Number(totalAmount).toFixed(2);
  };
  const getPassengerDetails = () => {
    return (
      <View style={styles.headerWrraper}>
        <Text style={styles.title}>Passenger Details</Text>
        <View style={styles.row}>
          <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
            Guest Name:{" "} 
            {ticketData?.Passengers.prefix}{" "}
            {ticketData?.Passengers.firstName}{" "}
            {ticketData?.Passengers.lastName}
          </Text>
          <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
            Email: {ticketData?.Passengers.email}
          </Text>
          <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
            Contact: {ticketData?.Passengers.mobile}
          </Text>
          {/* <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
            Pan Card No: {ticketData?.Passengers.pan_no}
          </Text> */}
        </View>
      </View>
    );
  };

  const getTourinfo = () => {
    return (
      <View style={{ ...styles.headerWrraper, ...styles.mb_5 }}>
        {ticketData.TourDetails?.[0].apikey === "EXT" ||
          ticketData.TourDetails?.[0].transferName === "Private Transfer" ? (
          <Text style={styles.title}>Transfer Details</Text>
        ) : (
          <Text style={styles.title}>Tour Details</Text>
        )}
        <View style={styles.row}>
          <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
            {/* Reference Number:{" "} */}
            {(ticketData.TourDetails?.[0].apikey === "EXT" ||
              ticketData.TourDetails?.[0].transferName ===
              "Private Transfer") &&
              ticketData.TourDetails?.[0].BookingStatus === "VOUCHERED"
              ? "Confirmation Number:"
              : "Booking ID:"}
            {ticketData?.TourDetails?.[0].referenceNumber}
          </Text>
          {!agent && (
            <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
              Provider Ref No: {ticketData?.TourDetails?.[0].ProviderRefNo}
            </Text>
          )}

          {ticketData?.TourDetails?.[0].confirmationNo != "" && (
            <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
              Confirmation No: {ticketData?.TourDetails?.[0].confirmationNo}
            </Text>
          )}

          {withFare ? (
            <>
              {/* <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
                Payment Mode:{" "}
                {ticketData.PartPayment.isPartPayment === true
                  ? " Part"
                  : " Full"}{" "}
                Payment
              </Text> */}
              {ticketData?.convienenceData?.amount != "" && (
                <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
                  Convienence Fee: {activeCurrency}{" "}
                  {currencyValue(
                    Number(ticketData?.convienenceData?.amount ?? 0).toFixed(2)
                  )}
                </Text>
              )}
              <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
                Total Amount: {activeCurrency} {currencyValue(totalAmount)}
              </Text>

              {discount != "" && (
                <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
                  Discount: - {activeCurrency}{" "}
                  {isNaN(discount) ? 0 : Number(discount).toFixed(2)}
                </Text>
              )}

              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginVertical: 4,
                }}
              >
                <Text
                  style={{
                    ...styles.subtitle,
                    ...styles.wHalf,
                    textAlign: "left",
                  }}
                >
                  Final Amount:
                </Text>
                <Text
                  style={{
                    ...styles.subtitle,
                    ...styles.wHalf,
                    textAlign: "center",
                    marginRight:"75px"
                  }}
                >
                  {activeCurrency} {currencyValue(getTotalAmount())}
                </Text>
              </View>

              {/* {ticketData.PartPayment.isPartPayment === true ? (
                <>
                  <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
                    Paid Amount: {activeCurrency}{" "}
                    {currencyValue(ticketData.PartPayment.partPaymentAmount)}
                  </Text>
                  <Text
                    style={{
                      ...styles.subtitle,
                      ...styles.wHalf,
                      ...styles.textDanger,
                    }}
                  >
                    Due Amount: {activeCurrency}{" "}
                    {currencyValue(ticketData.PartPayment.dueAmount)}
                  </Text>
                </>
              ) : null} */}
            </>
          ) : null}
          {ticketData?.Passengers?.specialReq != '' && (
            <View style={styles.row}>
              <View
                style={{
                  padding: 10,
                  borderRadius: 5,
                  backgroundColor: 'rgba(118, 137, 143, 0.39)', // #76898f63
                  borderWidth: 1,
                  borderColor: '#e9ecef',
                  width: '100%',
                  flexDirection: 'row',
                  alignItems:"center"
                  }}
              >
                <Text style={{ fontWeight: 'bold', fontSize: 10 }}>
                  Special Request:
                </Text>
                <Text style={{ fontSize: 10, marginLeft:'5px'}}>
                  {ticketData?.Passengers?.specialReq}
                </Text>
              </View>
            </View>
          )}
        </View>
      </View>
    );
  };

  const getTourDetails = (tour, index, ticketIndex = null, adults, childs) => {
    return (
      <View
        key={index + tour.tourName}
        style={styles.contentWrapper}
        wrap={true}
      >
        {/* <View style={styles.timelineBadge}>
          <Text>
            {dayjs(tour.journeyDate, "YYYY-MM-DD").format("DD MMM")}{" "}
          </Text>
        </View> */}

        <View style={styles.card} wrap={false}>
          <Text style={styles.title}>{tour.tourName}</Text>
          <Text
            style={{
              marginLeft: "50%",
              marginTop: -8,
              fontSize: 10,
              marginBottom: 12,
            }}
          />
          {/* <Text style={{ marginLeft: "82%", fontSize: "10px", paddingRight: "10px" }}>{formatDate(tour.journeyDate, "DD MMM YYYY")}</Text> */}
          <Text style={styles.subtitle}>{tour.optionName}</Text>
          {/* <Text style={styles.subtitle}>
            Tour Date :{" "}
            {dayjs(tour.journeyDate, "YYYY-MM-DD").format("ddd DD MMM YYYY")}
          </Text> */}
          <View
            style={{
              ...styles.mb10,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <View>
              {(() => {
                // Prefer thumbnail when a large activitylist image is present
                let imgSrc = tour?.tourImage || ticketData?.tourImage || LogoImg;
                if (
                  tour?.tourImage &&
                  tour.tourImage.includes("/trips/activitylist/") &&
                  ticketData?.tourImage
                ) {
                  imgSrc = ticketData.tourImage;
                }
                // Clean up potential whitespace/newline/quote issues that can break pdf-image loader
                if (typeof imgSrc === "string") {
                  imgSrc = imgSrc.trim().replace(/^['"]+|['"]+$/g, "");
                }
                // Debug image src for tours where image might not render
                if (index === 1) {
                  try {
                    console.log("[ActivitiesDoc] image debug", {
                      index,
                      tourName: tour?.tourName,
                      tourImage: tour?.tourImage,
                      ticketImage: ticketData?.tourImage,
                      resolvedSrc: imgSrc,
                    });
                  } catch (e) {}
                }
                return (
                  <Image
                    src={imgSrc}
                    style={{ height: 110, width: 180, marginBottom: 10 }}
                    allowDangerousPaths
                  />
                );
              })()}
            </View>
            {tour.hasOwnProperty('ticket') && tour.ticket.length > 0 ? (
              <View
                style={{
                  height: 110,
                  width: 110,
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {tour.ticket
                  .filter((t) => t?.barcodeImage)
                  .map((t, i) => (
                    <Image
                      key={i}
                      src={t.barcodeImage}
                      style={{
                        width: 70,
                        height: 70,
                        marginRight: 4,
                        marginBottom: 4,
                      }}
                      allowDangerousPaths
                    />
                  ))}
              </View>
            ) : !(tour?.apikey == 'EXT' || tour.bookingStatus === 11) ? (
              <View
                style={{
                  height: 110,
                  width: 110,
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderWidth: 2,
                  borderColor: '#e9ecef',
                  backgroundColor: '#f8f9fa',
                  opacity: 0.5,
                }}
              >
                <View style={{
                  width: 110,
                  height: 110,
                  borderWidth: 1,
                  borderColor: '#dee2e6',
                  backgroundColor: '#ffffff',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                  <Text style={{
                    fontSize: 8,
                    color: '#666',
                    textAlign: 'center'
                  }}>QR Code{"\n"}not Generated</Text>
                </View>
              </View>
            ) : null }
          </View>
          <View style={styles.description}>
            <Description tourShortDescription={tour.tourShortDescription} />
          </View>

          <View style={styles.container}>
            <View style={styles.row}>
              <Text style={styles.leftCell}>Booking Status </Text>
              <View style={styles.verticalLine} />
              <Text style={styles.rightCell}>
                {getStatus(tour.BookingStatus)}
              </Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.leftCell}>Travel Date </Text>
              <View style={styles.verticalLine} />
              <Text style={styles.rightCell}>
                {dayjs(tour.journeyDate, "YYYY-MM-DD").format(
                  "ddd DD MMM YYYY"
                )}
              </Text>
            </View>

            {tour.bookingStatus === 3 && tour.apikey === "EXT" && (
              <View style={styles.row}>
                <Text style={styles.leftCell}>Last Vouchered Date </Text>
                <View style={styles.verticalLine} />
                <Text style={styles.rightCell}>
                  {/* {formatDate(dayjs(tour.journeyDate, "YYYY-MM-DD").subtract(4, "days"), "ddd DD MMM YYYY")} */}
                  {dayjs(tour.journeyDate).diff(dayjs(), "days") >= 4
                    ? dayjs(tour.journeyDate)
                        .subtract(4, "days")
                        .format("ddd DD MMM YYYY")
                    : "Non-refundable"}
                </Text>
              </View>
            )}

            {tour.bookingStatus === 11 && tour.apikey === "EXT" && (
              <View style={styles.row}>
                <Text style={styles.leftCell}>Last Cancellation Date :</Text>
                <View style={styles.verticalLine} />
                <Text style={styles.rightCell}>
                  {/* {formatDate(dayjs(tour.journeyDate, "YYYY-MM-DD").subtract(4, "days"), "ddd DD MMM YYYY")} */}
                  {dayjs(tour.journeyDate).diff(dayjs(), "days") >= 4
                    ? dayjs(tour.journeyDate)
                        .subtract(4, "days")
                        .format("ddd DD MMM YYYY")
                    : "Non-refundable"}
                </Text>
              </View>
            )}

            <View style={styles.row}>
              <Text style={styles.leftCell}>Transfer Option </Text>
              <View style={styles.verticalLine} />
              <Text style={styles.rightCell}>{tour.transferName}</Text>
            </View>

            {tour.duration !== "" &&
              tour.apikey !== "EXT" &&
              tour.transferName !== "Private Transfer" && (
                <View style={styles.row}>
                  <Text style={styles.leftCell}>Duration </Text>
                  <View style={styles.verticalLine} />
                  <Text style={styles.rightCell}>{tour.duration}</Text>
                </View>
              )}

            {tour.timeSlotId !== "0" ? (
              <View style={styles.row}>
                <Text style={styles.leftCell}>Slot </Text>
                <View style={styles.verticalLine} />
                <Text style={styles.rightCell}>{tour.startTime}</Text>
              </View>
            ) : (
              <View style={styles.row}>
                <Text style={styles.leftCell}>
                  {tour.transferName === "Private Transfers"
                    ? "Pickup Time"
                    : "Start Time"}
                </Text>
                <View style={styles.verticalLine} />
                <Text style={styles.rightCell}>{tour.startTime}</Text>
              </View>
            )}

            {/* {tour.finishTime ? (
              <View style={styles.row}>
                <Text style={styles.leftCell}>
                  {tour.apikey === "EXT" ||
                  tour.transferName === "Private Transfer"
                    ? "Dropoff time"
                    : "Drop Time"}
                </Text>
                <View style={styles.verticalLine} />
                <Text style={styles.rightCell}>{tour.finishTime}</Text>
              </View>
            ) : null} */}

            {(adults > 0 || childs > 0) && (
              <View style={styles.row}>
                <Text style={styles.leftCell}>Number of Passengers </Text>
                <View style={styles.verticalLine} />
                <Text style={styles.rightCell}>
                  {adults > 0 || childs > 0
                    ? `${adults} Adults ${childs} Childs`
                    : 0}
                </Text>
              </View>
            )}

            {/* {tour?.ticket && tour?.ticket.length > 0 && (
              <View style={styles.row}>
                <Text style={styles.leftCell}>Slot </Text>
                <View style={styles.verticalLine} />
                <Text style={styles.rightCell}>{tour?.ticket?.map((ticket) => ticket?.timeSlot).join(', ')}</Text>
              </View>
            )} */}

            {tour.pickup !== "" && (
              <View style={styles.row}>
                <Text style={styles.leftCell}>
                  {tour.tourName.includes("Pick Up")
                    ? "Drop off Location"
                    : "Pickup Location"}
                </Text>
                <View style={styles.verticalLine} />
                <Text style={styles.rightCell}>{tour.pickup}</Text>
              </View>
            )}
            {/* { drop off start here } */}
            {/* {tour?.dropoff ? (
              <View style={styles.row}>
                <Text style={styles.leftCell}>
                  {tour.tourName.includes("Pick Up")
                    ? "Drop Off Location"
                    : "Pick Up Location"}
                  Drop Off Location
                </Text>
                <View style={styles.verticalLine} />
                <Text style={styles.rightCell}>{tour.dropoff}</Text>
              </View>
            ) : null} */}
            {tour?.tourName &&
            tour?.tourName
              .toLowerCase()
              .match(/\b(day|driver|taxi|car|point)\b/) &&
            tour?.apikey === "EXT" &&
            tour?.transferName !== "Without Transfers" &&
            tour?.dropoff ? (
              <View style={styles.row}>
                <Text style={styles.leftCell}>Drop off Location</Text>
                <View style={styles.verticalLine} />
                <Text style={styles.rightCell}>{tour.dropoff}</Text>
              </View>
            ) : null}
            {/* { drop off end here } */}

            {!tour.ticket && (
              <View style={styles.row}>
                <Text style={styles.leftCell}>Number Of Passengers </Text>
                <View style={styles.verticalLine} />
                <Text style={styles.rightCell}>{getPaxCount(tour.pax)}</Text>
              </View>
            )}



            {tour?.TransferObj?.FlightName && tour?.TransferObj?.FlightNo && (
              <>
                <View style={styles.row}>
                  <Text style={styles.leftCell}>Check-In Luggage </Text>
                  <View style={styles.verticalLine} />
                  <Text style={styles.rightCell}>
                    23 Kg/per * {tour?.TransferObj?.CheckLuggages} Pax
                  </Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.leftCell}>Hand Luggage </Text>
                  <View style={styles.verticalLine} />
                  <Text style={styles.rightCell}>
                    7 Kg/per * {tour?.TransferObj?.Handluggage} Pax
                  </Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.leftCell}>Flight/Train Name </Text>
                  <View style={styles.verticalLine} />
                  <Text style={styles.rightCell}>
                    {tour?.TransferObj?.FlightName}
                  </Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.leftCell}>Flight/Train Number </Text>
                  <View style={styles.verticalLine} />
                  <Text style={styles.rightCell}>
                    {tour?.TransferObj?.FlightNo}
                  </Text>
                </View>
              </>
            )}

            {/* {withFare && (
              <View style={styles.row}>
                <Text style={styles.leftCell}>Amount </Text>
                <View style={styles.verticalLine} />
                <Text style={styles.rightCell}>
                  {activeCurrency}{" "} {currencyValue(tour.serviceTotal?.toFixed(2))}
                </Text>
              </View>
            )} */}
          </View>

          {/* {!(
            tour.apikey === "EXT" || tour.transferName === "Private Transfer"
          ) && (
            <View style={styles.description}>
              <Text style={styles.title}>Cancellation Policy</Text>
              <Text
                style={{
                  display: "inline",
                  color: "red",
                  textAlign: "justify",
                }}
              >
                {tour.ticketPolicy[0]?.cancellationPolicyDescription?.replace(
                  /<[^>]*>?/gm,
                  ""
                )}
              </Text>
            </View>
          )} */}
        </View>
      </View>
    );
  };
  const getImportantNote = () => (
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        {/* {tour.apikey === "EXT" && ( */}
        <View style={styles.description1}>
          <Text style={styles.title}>Important Note:</Text>
          <Text style={styles.note}>
            <Text style={styles.bullet}>1. </Text>
            In the event of a vehicle breakdown or tyre puncture during a
            transfer, you are required to wait until the issue is resolved by
            the driver.
          </Text>
          <Text style={styles.note}>
            <Text style={styles.bullet}>2. </Text>
            In Europe, drivers are not obligated to assist with loading or
            unloading luggage into the vehicle.
          </Text>
          <Text style={styles.note}>
            <Text style={styles.bullet}>3. </Text>
            For airport pickups, ensure you're picked up within one hour of
            landing. Delays are subject to the driver’s availability. Contact
            the emergency number.
          </Text>
          <Text style={styles.note}>
            <Text style={styles.bullet}>4. </Text>
            If a guest spills food or drink inside the vehicle, they must clean
            it or pay a fine to the driver.
          </Text>

          <View style={styles.tableSection}>
            <Text style={styles.title1}>
              Emergency Contact details according to destination - All Time in
              IST
            </Text>
            <View style={[styles.row1, styles.headerCell]}>
              <Text style={styles.cell}>Country</Text>
              <Text style={styles.cell}>Time (10:00 to 06:00 PM)</Text>
              <Text style={styles.cell}>Staff Name</Text>
              <Text style={[styles.cell, styles.lastCell]}>
                Staff Number After (06:00 PM)
              </Text>
            </View>
            {contactData.map(([country, time, staff, number], index) => (
              <View style={styles.row1} key={index}>
                <Text style={styles.cell}>{country}</Text>
                <Text style={styles.cell}>{time}</Text>
                <Text style={styles.cell}>{staff}</Text>
                <Text style={[styles.cell, styles.lastCell]}>{number}</Text>
              </View>
            ))}
          </View>
        </View>
        {/* )} */}
      </View>
    </Page>
  );

  const getShortAddress = (add) => {
    let addressArr = add.split(" ");
    let Text = "";
    for (let i = 0; i < addressArr.length; i += 3) {
      Text += addressArr[i] + " ";
    }
    return Text;
  };
  const contactData = [
    ["India", "+91 11 49511313", "Sonal & Bulbul", "9811906582, 9811294417"],
    ["Dubai", "+91 11 49511313", "Sonal & Bulbul", "9811906582, 9811294417"],
    ["Baku", "+91 11 49511313", "Sonal & Bulbul", "9811906582, 9811294417"],
    ["USA", "+91 11 49511313", "Rahul Parmar", "8130993954, +1(559)547-9778"],
    [
      "Europe",
      "+91 11 49511313",
      "Rahul Parmar",
      "8130993954, +39-37154-04210",
    ],
    ["Turkey", "+91 11 49511313", "Bulbul", "9811294417"],
    ["Bali", "+91 11 49511313", "Sonal", "9811906582"],
    ["Singapore", "+91 11 49511313", "Sonal", "9811906582"],
    [
      "Japan",
      "+91 11 49511313",
      "Rahul Parmar & Bulbul",
      "8130993954, 9811294417",
    ],
    [
      "Australia",
      "+91 11 49511313",
      "Rahul Parmar",
      "8130993954, +61-43137-3179",
    ],
    ["New Zealand", "+91 11 49511313", "Rahul Parmar", "8130993954"],
  ];

  // Generate ticket layout – logo + company header, passenger, transfer, and tour details
  const generateTicketHTML = () => {
    if (!ticketData || !ticketData.TourDetails || ticketData.TourDetails.length === 0) {
      return null;
    }

    const pages = [];
    let isFirstPage = true;
    
    ticketData.TourDetails.forEach((tour, tourIndex) => {
      if (tour.hasOwnProperty('ticket') && tour.ticket.length > 1) {
        // Create separate page for each barcode
        tour.ticket.forEach((ticket, ticketIndex) => {
          const tourWithSingleTicket = {
            ...tour,
            ticket: [ticket]
          };
          pages.push(createPage([tourWithSingleTicket], isFirstPage));
          isFirstPage = false;
        });
      } else {
        // Single or no barcode - add to page
        pages.push(createPage([tour], isFirstPage));
        isFirstPage = false;
      }
    });
    
    return pages;
  };

  const createPage = (tours, includeHeader) => {
    return (
      <Page size="A4" style={styles.page} wrap={true}>
        <View style={styles.section}>
          {includeHeader && (
            <>
              {/* Company header with logo and agent/admin details */}
              <View style={styles.logoSection}>
                <View style={{ ...styles.flex5 }}>
                  {Logo ? (
                    <Image
                      src={BASE + Logo.substring(1)}
                      style={{ height: 50, width: 100, marginBottom: 10 }}
                    />
                  ) : (
                    <Image style={{ width: 100, heigh: 50 }} src={LogoImg} />
                  )}
                </View>

                <View style={{ ...styles.flex5, ...styles.addressDetails, ...styles.addressBox }}>
                  {ticketData?.agentDetails ? (
                    <Text style={styles.addressText}>
                      {ticketData.agentDetails.AgencyName}
                      {"\n"}
                      {ticketData.agentDetails.Address1}{" "}
                      {ticketData.agentDetails.Address2}
                      {"\n"}
                      {ticketData.agentDetails.City}{" "}
                      {ticketData.agentDetails.State}
                      
                      Email: {ticketData.agentDetails.Email}
                      {"\n"}
                      {ticketData.agentDetails.Phone
                        ? `Contact No.: ${ticketData.agentDetails.Phone}`
                        : ""}
                    </Text>
                  ) : ticketData?.adminDetails &&
                    ticketData.adminDetails.length > 0 ? (
                    <Text style={styles.addressText}>
                      {ticketData.adminDetails[0].Address}
                      {"\n"}
                      {ticketData.adminDetails[0].CityName}{" "}
                      {ticketData.adminDetails[0].StateName}
                      {"\n"}
                      {ticketData.adminDetails[0].CountryName}{" "}
                      {ticketData.adminDetails[0].PostalCode}
                    </Text>
                  ) : null}
                </View>
              </View>

              {/* Passenger + transfer blocks */}
              {getPassengerDetails()}
              {getTourinfo()}
            </>
          )}
          
          {/* Tour details */}
          {tours.map((tour, index) => getTourDetails(tour, index))}
        </View>
      </Page>
    );
  };

  return (
    <Document>
      {generateTicketHTML()}
      {getImportantNote()}
    </Document>
  );
};

export default ActivitiesDoc;
